import * as React from "react";
const SvgFiRrNotFound = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m16.707 13.207-.543.543.543.543a.999.999 0 1 1-1.414 1.414l-.543-.543-.543.543a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l.543-.543-.543-.543a.999.999 0 1 1 1.414-1.414l.543.543.543-.543a.999.999 0 1 1 1.414 1.414M9.25 15.164l.543.543a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-.543-.543.543-.543a.999.999 0 1 0-1.414-1.414l-.543.543-.543-.543a.999.999 0 1 0-1.414 1.414l.543.543-.543.543a.999.999 0 1 0 1.414 1.414zM4.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 4.5 7m4 0a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 8.5 7M24 6v12c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V6c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5M2 6v2h20V6c0-1.654-1.346-3-3-3H5C3.346 3 2 4.346 2 6m20 12v-8H2v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3m-7.143-.434c-1.994-.762-3.72-.762-5.714 0a1 1 0 1 0 .714 1.868c1.53-.584 2.756-.584 4.286 0a.997.997 0 0 0 1.291-.578 1 1 0 0 0-.577-1.29"
    />
  </svg>
);
export default SvgFiRrNotFound;
